import { useEffect } from "react";

export default function Seo({ title, description }) {
    useEffect(() => {
        document.title = title;
        const setMeta = (selector, attr, content) => {
            const el = document.querySelector(selector);
            if (el) el.setAttribute(attr, content);
        };
        setMeta('meta[name="description"]', "content", description);
        setMeta('meta[property="og:title"]', "content", title);
        setMeta('meta[property="og:description"]', "content", description);
        setMeta('meta[name="twitter:title"]', "content", title);
        setMeta('meta[name="twitter:description"]', "content", description);
    }, [title, description]);
    return null;
}
